import { useEffect, useState } from 'react';

const ROTATION_INTERVAL = 3000;

export const useRotatingPlaceholder = (placeholders: Array<string>, fallback: string): string => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!placeholders?.length) {
      setIndex(0);
      return;
    }

    setIndex(prev => (prev >= placeholders.length ? 0 : prev));

    const timer = setInterval(() => {
      setIndex(prev => (prev + 1) % placeholders.length);
    }, ROTATION_INTERVAL);

    return () => clearInterval(timer);
  }, [placeholders]);

  if (!placeholders?.length) return fallback;

  return placeholders[index] ?? fallback;
};
